module.exports = __webpack_public_path__ + "img/control_panel_icon_512 1 1@2x.86df02e8.png";